import { defineSlotRecipe as o } from "@pandacss/dev";
import { checkbox as e } from "@huspy/briks-core";
import { anatomy as s } from "../../node_modules/@ark-ui/anatomy/dist/checkbox/index.mjs";
const a = o({
  className: "briks-checkbox",
  slots: s.keys(),
  base: {
    root: {
      display: "flex",
      alignItems: "center",
      gap: "spacing-2"
    },
    control: {
      transition: "all 0.1s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...e.base,
      _hover: e.hover,
      _checked: {
        ...e.checked,
        svg: {
          color: "white"
        },
        _hover: {
          ...e.hover,
          svg: {
            // we use absolute with svg as icons doesn't support our color tokens for now
            color: "#9CA3AF"
          }
        },
        _active: {
          ...e.pressed
        }
      },
      "&[data-disabled]": {
        ...e.disabled,
        svg: {
          color: "#9CA3AF"
        },
        _hover: {
          ...e.disabled
        }
      }
    }
  }
});
export {
  a as checkboxRecipe
};
